import Fragment from "./fragment";

export default class NoPlay extends Fragment {}
